'use client';

import { Link, Image, Box } from "@chakra-ui/react";
import LogoSvg from '@/lib/logo';

export default function Logo() {
  return (
    <Link href="/" display="block">
      <Box w="100%">
        <LogoSvg />
      </Box>
    </Link>
  )
}
